import apiCaller from "../../utils/api";
import { fetchUserProfile } from "../actions";

function fetchLoggedInUser() {
  return dispatch => apiCaller.getRequest(
    "user/me",
    {},
    res => {
      dispatch(fetchUserProfile(res));
    },
    err => {
      dispatch(fetchUserProfile({}));
      return {};
    }
  );
}
export default fetchLoggedInUser;
